import { querySelectorAll } from 'dom101'

export function qs(...args) {
  const [el, sel] = args.length === 2 ? args : [document, args[0]]
  return el && el.querySelector(sel)
}

export function qsa(el, sel) {
  return querySelectorAll(el, sel)
}
